<template>
		<div>
			<div class="main-header">
				<div class="container">
					<h2 class="main-header-text">OTP - Phone Number Confirmation</h2>
				</div>
			</div>
			<!-- eo main header -->
			<div class="main-section mgt-40">
				<div class="container">
					<div class="main-card text-center">
						<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
						<div class="main-card-header">
							<h2>Please wait while we verify your number</h2>
							<p>{{vModel.MaskedMobileNumber}}</p>
						</div>
						<div class="rate-box otp-box otp">
							<div class="form-card-forms">
								<h4 class="header">Verification</h4>
								<h4 class="detail">To proceed, please enter your OTP number</h4>
								<div class="otp-form">
									<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
										<div class="form-group">
											<input type="text" placeholder="Enter OTP" class="form-control otp" id="otp" name="OTP" v-only-numeric="" style="height:72px"
														 autocomplete="off"
														 v-model="vModel.Key"
														 v-validate="'required|min:6|max:6'"
														 :class="{'input': true, 'is-danger': errors.has('OTP') }" />
											<div v-show="errors.has('OTP')"
													 class="help is-danger">
												{{ errors.first('OTP') }}
											</div>
										</div>
										<button class="btn main-btn">Verify</button>
									</form>
								</div>
							</div>
						</div>
						<div class="rate-option-btn">
							<div class="submit-option maxw-700">
								<div class="left-option">
									<router-link :to="'/account/login'" class="btn submit-lefticon-btn">
										<span class="left-icon">
											<i class="fas fa-angle-left"></i>
										</span>
										<span class="btn-content">Cancel</span>
									</router-link>
								</div>
								<div class="right-option">
									<p>
										Didn't get the code? <a href="javascript:void(0)" class="resend" @click="onResendOtp">Resend OTP?</a>
									</p>
								</div>
							</div>
						</div>
						<!-- eo main card -->
					</div>
					<!-- eo main card -->
				</div>
				<!-- eo container -->
			</div>
			<!-- eo main section -->
		</div>
	</template>
	<script>
		
		import CommonService from "../../services/common";
		export default {
			name: "PhoneNumberConfirm",
			created() {
				this.vModel.MobileNumber = CommonService.getStorage("RegistrationMobileNumber");
				this.vModel.MaskedMobileNumber = MaskCharacter(this.vModel.MobileNumber);
			},
			beforeRouteEnter(to, from, next) {
				next(p => {
					p.vModel.OtpId = to.params.id
				});
			},
			data() {
				return {
					vModel: {
						OtpId: "",
						Key: "",
						MobileNumber: "",
						MaskedMobileNumber: ""
					}
				};
			},
			methods: {
				onSubmit: function () {
					var self = this;
					if (self.isProcessing) return false;
					self.$validator.validateAll().then(result => {
						if (result) {
							self.isProcessing = true;
							self.$http.post("v2/account/register/confirmphone", self.vModel).then(
								response => {
								self.isProcessing = false;
								self.$router.push("/account/registration/passphrase/" + self.vModel.OtpId);	
									
								},
								error => {
									self.isProcessing = false;
								}
							);
						}
					});
				},
				onResendOtp: function () {
					var self = this;
					self.isProcessing = true;
					self.$http.post("mobile/otp/resend", self.vModel).then(
						response => {
							self.$toastr("success", "OTP Resend Successfully");
							self.isProcessing = false;
						},
						error => {
							self.isProcessing = false;
						}
					);
				},
				onClearForm: function () {
					this.vModel = {
						OtpId: "",
						Key: ""
					};
					this.errors.clear();
				}
			}
		};
		function MaskCharacter(str) {
			var masked = "";
			if (str.length >= 7) { // make sure the string is at least 7 characters long
				var prefix = str.slice(0, 4); // get the first 4 characters
				var suffix = str.slice(-3); // get the last 3 characters
				var maskLength = str.length - 7; // calculate the length of the masked characters
				var mask = "X".repeat(maskLength); // create a mask of asterisks with the same length
				masked = prefix + mask + suffix; // concatenate the masked parts
			}
			return masked;
		}
	</script>
